import { render, staticRenderFns } from "./CloseFormOverlay.vue?vue&type=template&id=85f4eb9a&"
import script from "./CloseFormOverlay.js?vue&type=script&lang=js&"
export * from "./CloseFormOverlay.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/staging.mijnmooiestraat.vlaanderen/pro-staging.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85f4eb9a')) {
      api.createRecord('85f4eb9a', component.options)
    } else {
      api.reload('85f4eb9a', component.options)
    }
    module.hot.accept("./CloseFormOverlay.vue?vue&type=template&id=85f4eb9a&", function () {
      api.rerender('85f4eb9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/CloseFormOverlay/CloseFormOverlay.vue"
export default component.exports